import {
    AccountTerms,
    ConnectPayload,
    AccountConnect,
    CreateAccountConnect,
    NewsletterStatusEnum,
    NewsletterScopeEnum,
    Newsletter,
    NewsletterPayload,
    SimpleNewsletter
} from "@dev/ee-api/ee-api-models";
import { AxiosPromise, AxiosResponse } from "axios";
import { request } from "./request";

export type GetPaidNewslettersParams = {
    from?: string;
    to?: string;
    search?: string;
    limit?: number;
    offset?: number;
    statusList?: NewsletterStatusEnum[];
    loadingTemplates?: boolean;
    page?: number;
    templatesList?: SimpleNewsletter[];
    count?: number;
    publishedCount?: number;
    unpublishedCount?: number;
    scope?: NewsletterScopeEnum;
};
export const loadPaidNewsletters = ({ limit, offset, statusList, search, from, to, scope = NewsletterScopeEnum.Private}: GetPaidNewslettersParams): AxiosPromise<Newsletter[]> => {
    const { PaidNewsletters } = request();
    return PaidNewsletters.newslettersListGet(statusList, scope, search, from, to, limit, offset).then((resp): AxiosResponse<Newsletter[]> => resp);
};

export const loadPaidNewsletter = (name: string): Promise<Newsletter> => {
    const { PaidNewsletters } = request();
    return PaidNewsletters.newslettersByNameGet(name).then((resp): Newsletter => resp.data);
};

export const updatePaidNewsletterStatus = (name: string, status: NewsletterStatusEnum): Promise<NewsletterStatusEnum> => {
    const { PaidNewsletters } = request();
    return PaidNewsletters.newslettersByNameByStatusPut(name, status).then((resp): NewsletterStatusEnum => resp.data);
}

export const savePaidNewsletter = (paidNewsletter: NewsletterPayload, name?: string): Promise<Newsletter> => {
    const { PaidNewsletters } = request();
    if (name) {
        return PaidNewsletters.newslettersByNamePut(name, paidNewsletter).then((resp): Newsletter => resp.data);
    }

    return PaidNewsletters.newslettersPost(paidNewsletter).then((resp): Newsletter => resp.data);
};

export const loadPaidNewslettersTerms = (): AxiosPromise<AccountTerms> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsTermsGet();
};

export const paidNewslettersTermsPost = (payload: AccountTerms): AxiosPromise<AccountTerms> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsTermsPost(payload).then((resp): AxiosResponse<AccountTerms> => resp);
};
export const modifyPaidNewslettersTerms = (payload: AccountTerms): AxiosPromise<AccountTerms> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsTermsPut(payload).then((resp): AxiosResponse<AccountTerms> => resp);
};

export const deletePaidNewsletters = (paidNewsletterNames: string[]): AxiosPromise<void> => {
    const { PaidNewsletters } = request();

    return PaidNewsletters.newslettersDelete(paidNewsletterNames);
};

// checkoutsAccount
export const fetchPaidNewslettersAccount = (): AxiosPromise<AccountConnect> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsAccountGet().then((resp): AxiosResponse => resp);
};
export const updatePaidNewslettersAccount = (payload: ConnectPayload): AxiosPromise<CreateAccountConnect> => {
    const { Checkouts } = request();
    return Checkouts.checkoutsAccountPost(payload);
};
